// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.game-input {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
}
.game-input .game-input-textbox-container {
  justify-content: center;
  display: flex;
  gap: 10px;
}
.game-input .game-input-textbox-container .game-input-textbox {
  display: flex;
  gap: 10px;
}
.game-input .game-input-matrix-container {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  max-width: 300px;
  margin: auto;
}
.game-input .game-input-matrix-container .game-input-matrix {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 10px;
  border: 1px solid black;
  min-width: 80px;
  text-align: center;
}
`, "",{"version":3,"sources":["webpack://./src/pages/game_input_page/GameInput.less"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,SAAA;AACJ;AALA;EAMQ,uBAAA;EACA,aAAA;EACA,SAAA;AAER;AAVA;EAUY,aAAA;EACA,SAAA;AAGZ;AAdA;EAgBQ,aAAA;EACA,qCAAA;EACA,gBAAA;EACA,YAAA;AACR;AApBA;EAsBY,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;EACA,uBAAA;EACA,eAAA;EACA,kBAAA;AACZ","sourcesContent":[".game-input {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    gap: 10px;\n    .game-input-textbox-container {\n        justify-content: center;\n        display: flex;\n        gap: 10px;\n        .game-input-textbox {\n            display: flex;\n            gap: 10px;\n        }\n    }\n\n    .game-input-matrix-container {\n        display: grid;\n        grid-template-columns: repeat(3, 1fr);\n        max-width: 300px;\n        margin: auto;\n    \n        .game-input-matrix {\n            display: flex;\n            align-items: center;\n            justify-content: center;\n            padding: 10px;\n            border: 1px solid black;\n            min-width: 80px;\n            text-align: center;\n        }\n    }\n}\n\n  "],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
